import Hr from './DividerStyles';

export const Divider = () => <Hr />;

export default Divider;
